import { render, staticRenderFns } from "./AssistantListPage.vue?vue&type=template&id=7586ae5e&scoped=true&"
import script from "./AssistantListPage.vue?vue&type=script&lang=js&"
export * from "./AssistantListPage.vue?vue&type=script&lang=js&"
import style0 from "./AssistantListPage.vue?vue&type=style&index=0&id=7586ae5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7586ae5e",
  null
  
)

export default component.exports